import { NavLink } from 'react-router-dom';
import leoraIcon from '../../assets/leoraIcon_black.png';
import './AdminSidebar.css';

const NAV_ITEMS = [
  { to: '/leoradmin', label: 'Dashboard', end: true },
  { to: '/leoradmin/categorias', label: 'Categorías' },
  { to: '/leoradmin/marcas', label: 'Marcas' },
  { to: '/leoradmin/productos', label: 'Productos' },
  { to: '/leoradmin/proveedores', label: 'Proveedores' },
];

export default function AdminSidebar({ open, onClose, user, onLogout }) {
  return (
    <aside className={`admin-sidebar ${open ? 'open' : ''}`}>
      <div className="admin-sidebar__top">
        <div className="admin-sidebar__brand">
          <img src={leoraIcon} alt="Leora" className="admin-sidebar__logo" />
        </div>
        <nav className="admin-sidebar__nav" aria-label="Admin">
          {NAV_ITEMS.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) =>
                `admin-sidebar__link${isActive ? ' active' : ''}`
              }
              onClick={onClose}
            >
              {item.label}
            </NavLink>
          ))}
        </nav>
      </div>

      <div className="admin-sidebar__footer">
        <div className="admin-sidebar__user">
          <strong>{user?.username}</strong>
          <span>Administrador</span>
        </div>
        <button type="button" className="admin-btn admin-btn--secondary admin-sidebar__logout" onClick={onLogout}>
          Cerrar sesión
        </button>
      </div>
    </aside>
  );
}
